// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  whatsappUrl: 'https://graph.facebook.com/v20.0/325118687361165/messages',
  whatsappToken: 'EAAHGfIb0mLIBO1nAphm77r0Sk1EiZAahHgOboiXSZCdzMTZCYLDtFzc8fjQf7wuoICNpcqX5qyQRJTM36B6JIBKVnZBuXR67C3WZC6tsxSRdAjNcYfP157n1VnuPKzVFa2Vl8MygD7K5cXkwcARIcPOjiKt93vF4CjmZB0MpWLd4ZA8eV32vIMi3DM3tXaCPYTf58QNsBNfpYwlzy8peocRKNf735YZD',
};
